import { render, staticRenderFns } from "./roleDeptChoice.vue?vue&type=template&id=1e4c7d0f&scoped=true&"
import script from "./roleDeptChoice.vue?vue&type=script&lang=ts&"
export * from "./roleDeptChoice.vue?vue&type=script&lang=ts&"
import style0 from "./roleDeptChoice.vue?vue&type=style&index=0&id=1e4c7d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4c7d0f",
  null
  
)

export default component.exports